import React from "react";
import { Modal, Box, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../Components/shared/CustomButton";
import { useDispatch } from "react-redux";

const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  height: 250,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
};

const WarningPopup = ({ open, message }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch({ type: "SET_WARNING_POPPEDUP" });
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-warning-popup"
      aria-describedby="modal-warning-popup"
    >
      <Box sx={Modalstyle}>
        <Box
          sx={{
            bgcolor: "#050D2E",
            height: "25%",
            color: "#ffffff",
            pr: 4,
            pl: 4,
            mb: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 550,
              lineHeight: "24px",
            }}
          >
            Warning
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
        </Box>

        <Typography
          sx={{
            color: "#50566E",
            fontSize: "1rem",
            lineHeight: "24px",
            mt: 2,
            p: "11px",
          }}
        >
          {message}
        </Typography>

        <Grid
          container
          justifyContent="flex-end"
          sx={{
            pr: 4,
            pl: 4,
            height: "25%",
            display: "flex",
            alignItems: "center",
            mt: 3,
          }}
        >
          <CustomButton
            text="Noted"
            type="update"
            processing={false}
            action={handleClose}
          />
        </Grid>
      </Box>
    </Modal>
  );
};

export default WarningPopup;
